import { RemoteExportSuspectedManipulation } from 'data/usecases';
import { ExportSuspectedManipulationUseCaseInterface } from 'domain/usecases';
import { makeApiUrlExportSuspectedManipulation } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeExportSuspectedManipulation =
  (): ExportSuspectedManipulationUseCaseInterface =>
    new RemoteExportSuspectedManipulation(
      makeApiUrlExportSuspectedManipulation(),
      makeAxiosHttpClient(),
    );
